module.exports = __webpack_public_path__ + "static/media/BebasNeue-Pro-Regular.d0f85ae2.otf";